'use client';
import { cn } from '@ecom/helper-react-class-combine';
import { toggleCookieBanner } from '@ecom/storefront-consent/onetrust';

export const OpenCookieSettingsLink = ({ label }: { label: string }) => {
  const handleCookieClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    toggleCookieBanner();
  };
  return (
    <span className={cn('mt-px mr-2 w-6 transition-[width,margin] duration-300 ease-in-out')}>
      <button
        className={cn(
          'text-m whitespace-nowrap transition-colors',
          'focus-visible:ring-primary lg:hover:text-text-hover focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2',
        )}
        onClick={handleCookieClick}
        type='button'
        aria-label={label}
      >
        {label}
      </button>
    </span>
  );
};
